export default "__VITE_ASSET__2Z8r64HX__"